export const privateRoutes = {
  home: {
    path: '/home',
    title: 'Dashboard',
  },
  simulator: {
    path: '/simulator',
    title: 'Simulador',
  },
  onboarding_b2b: {
    path: '/onboarding_b2b',
    title: 'Registro',
    step1: {
      path: '/onboarding_b2b/step1',
      title: 'Paso 1',
    },
    step2: {
      path: '/onboarding_b2b/step2',
      title: 'Paso 2',
    },
    step3: {
      path: '/onboarding_b2b/step3',
      title: 'Paso 3',
    },
    step4: {
      path: '/onboarding_b2b/step4',
      title: 'Perfil de Riesgo',
    },
    step5: {
      path: '/onboarding_b2b/step5',
      title: 'Previsualización del Contrato',
    },
  },
  movements: {
    path: '/movements',
    title: 'Movimientos',
  },
  fundswitch: {
    path: '/fundswitch',
    title: 'Traspasos',
  },
  referrals: {
    path: '/referrals',
    title: 'Referidores',
  },
  rescue: {
    path: '/rescue',
    title: 'Retiros',
  },
  configuration: {
    path: '/configuration',
    title: 'Configuración',
    changePassword: {
      fullpath: '/configuration/security',
      path: '/security',
      title: 'Contraseña',
    },
    account: {
      path: '/account',
      fullpath: '/configuration/account',
      title: 'Cuentas Bancarias',
      add: {
        fullpath: '/configuration/account/add',
        path: '/account/add',
        title: '',
      },
    },
    employees: {
      path: '/employees',
      fullpath: '/configuration/employees',
      title: 'Empleados',
    },
    institutional: {
      path: '/institutional',
      fullpath: '/configuration/institutional',
      title: 'Institucional',
    },
  },
  documents: {
    path: '/documents',
    title: 'Documentos',
    accountStatement: {
      fullpath: '/documents/account-statement',
      path: '/account-statement',
      title: 'Estado de Cuenta',
    },
  },
  funding: {
    path: '/funding/add-subscription',
    title: '',
  },
  learn: {
    path: '/learn',
    title: 'Nuestros fondos',
  },
  'final-beneficiary': {
    path: '/final-beneficiary',
    title: 'Beneficiario Final',
    add: {
      path: '/final-beneficiary/add',
      title: 'Agregar Beneficiario Final',
    },
    generateDj: {
      path: '/final-beneficiary/generate-dj',
      title: 'Generar Declaración Jurada',
    },
  },
};

export const publicRoutes = {
  signin: {
    path: '/',
    title: '',
  },
  forgotPassword: {
    path: '/forgot-password',
    title: '',
  },
  createCustomer: {
    path: '/create-customer',
    title: '',
  },
};
